import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    users: [],
    salesReps: [],
});

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUsers: (state, action) => {
            localStorage.setItem(`users`, JSON.stringify(action.payload));
            state.users = action.payload;
        },
        setSalesReps: (state, action) => {
            localStorage.setItem(`salesReps`, JSON.stringify(action.payload));
            state.salesReps = action.payload;
        },
    },
});

export const { setUsers, setSalesReps } = usersSlice.actions;

export default usersSlice.reducer;
